module.exports = __webpack_public_path__ + "c0fbfc6b4991b99c69b728ad71c47e2d.jpg";